/* tslint:disable */
/* eslint-disable */
/**
 * Wire API (development)
 * The API for the Clientwire messaging service.
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: support@clientwire.net
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const Activity = {
    MessageSeen: 'MESSAGE_SEEN',
    IsTyping: 'IS_TYPING',
    HasConversationOpen: 'HAS_CONVERSATION_OPEN'
} as const;
export type Activity = typeof Activity[keyof typeof Activity];


export function instanceOfActivity(value: any): boolean {
    for (const key in Activity) {
        if (Object.prototype.hasOwnProperty.call(Activity, key)) {
            if (Activity[key as keyof typeof Activity] === value) {
                return true;
            }
        }
    }
    return false;
}

export function ActivityFromJSON(json: any): Activity {
    return ActivityFromJSONTyped(json, false);
}

export function ActivityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Activity {
    return json as Activity;
}

export function ActivityToJSON(value?: Activity | null): any {
    return value as any;
}

export function ActivityToJSONTyped(value: any, ignoreDiscriminator: boolean): Activity {
    return value as Activity;
}

